exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".detail-padding[data-v-c6d2bd6a]{padding-left:10%;padding-right:10%}.common-card[data-v-c6d2bd6a]{border-radius:.16rem;padding:.32rem .24rem}.exchange-detail .detail-title-1[data-v-c6d2bd6a]{margin-bottom:.24rem}.exchange-detail .td-type-img[data-v-c6d2bd6a]{width:.52rem;margin-right:.16rem}.search-form[data-v-c6d2bd6a]{justify-content:end}", ""]);

// exports
